import {
  type ReactElement,
  type ReactNode,
  createContext,
  useContext,
} from "react";

const AppDialogTitleIdContext = createContext<string | undefined>(undefined);

type Props = {
  titleId: string | undefined;
  children: ReactNode;
};

/** Carries the title id from `AppDialog` to `AppDialogHeader`; MUI's own `Dialog/DialogContext` cannot be imported here. */
export function AppDialogTitleIdProvider({
  titleId,
  children,
}: Props): ReactElement {
  return (
    <AppDialogTitleIdContext.Provider value={titleId}>
      {children}
    </AppDialogTitleIdContext.Provider>
  );
}

/** `undefined` outside an `AppDialog`, and when the caller names the dialog from another element. */
export function useAppDialogTitleId(): string | undefined {
  return useContext(AppDialogTitleIdContext);
}
